import { useTranslation } from 'react-i18next';
export function useMissionsTranslation() {
    return useTranslation('missions');
}
